module.exports = __webpack_public_path__ + "static/media/catalogs.6a45df2e.jpg";